var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoTypeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.527,
    height: 38.019,
    viewBox: "0 0 37.527 38.019",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hd-5",
    transform: "translate(-5.123 -4.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M40.738,77.136H14.709a3.226,3.226,0,0,0-5.214,0H7.034a1.912,1.912,0,0,0,0,3.823H9.5a3.227,3.227,0,0,0,5.214,0H40.738a1.912,1.912,0,1,0,0-3.823ZM8.378,80.11H7.034a1.062,1.062,0,0,1,0-2.124H8.378a3.826,3.826,0,0,0,0,2.124ZM12.1,81.435a2.387,2.387,0,1,1,2.388-2.387A2.39,2.39,0,0,1,12.1,81.435ZM40.738,80.11H15.827a3.821,3.821,0,0,0,0-2.124H40.738a1.062,1.062,0,1,1,0,2.124Z",
    transform: "translate(0 -39.698)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M38,29.661V40.224l9.148-5.282Zm1.016,1.761,6.1,3.521-6.1,3.522Z",
    transform: "translate(-19.069 -14.849)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M37.976,4.567H9.8A4.678,4.678,0,0,0,5.123,9.24V30.482A4.678,4.678,0,0,0,9.8,35.155h28.18a4.679,4.679,0,0,0,4.673-4.673V9.24A4.679,4.679,0,0,0,37.976,4.567ZM41.8,30.482A3.828,3.828,0,0,1,37.976,34.3H9.8a3.828,3.828,0,0,1-3.824-3.823V9.24A3.828,3.828,0,0,1,9.8,5.417h28.18A3.828,3.828,0,0,1,41.8,9.24V30.482Z",
    transform: "translate(0)",
    fill: "#404040"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoTypeIcon);
export default __webpack_public_path__ + "static/media/videoTypeIcon.4d36adcadbe48616961308780378f280.svg";
export { ForwardRef as ReactComponent };